var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('autocomplete',{staticStyle:{"width":"400px"},attrs:{"search":_vm.search,"placeholder":"Введите ID или текст для поиска","aria-label":"Введите ID или текст для поиска","get-result-value":_vm.getResultValue},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }